import { Column, Row } from "components/Layout";
import { Label, Error } from "components/Form/FormikControls";

import React from "react";
import { useSelector } from "react-redux";
import {
  getDeploymentIdBySaleLotId,
  getDescriptionByBuyerSplitId,
  getSaleLotById,
} from "selectors";
import { useGetBestMatchingBuyerSplit } from "hooks/useGetBestMatchingVendorSplit";
import { useFieldValue } from "hooks";
import { Paper } from "components/Paper";
import { SlimSecondaryButton } from "components/Button";
import { openModalLink } from "lib/navigation";
import { ModalTypes } from "constants/navigation";

export const BuyerSplit = () => {
  const saleLotId = useFieldValue("id");
  const formBuyerId = useFieldValue("buyer_id");
  const primaryBusinessId = useSelector(getSaleLotById(saleLotId))?.buyer_id;

  const deploymentId = useSelector(
    getDeploymentIdBySaleLotId(saleLotId),
  ) as number;

  const split = useGetBestMatchingBuyerSplit({
    primaryBusinessId,
    deploymentId,
    consignmentId: null,
    saleLotId,
  });
  const splitDescriptions = useSelector(
    getDescriptionByBuyerSplitId(split?.id),
  ) as string[];

  if (!saleLotId) {
    return null;
  }

  const onClickCreateBuyerSplit = () =>
    openModalLink(ModalTypes.BuyerSplit, {
      primaryBusinessId,
      saleLotId,
    });

  const disabled = !primaryBusinessId || formBuyerId !== primaryBusinessId;

  return (
    <Column fullWidth>
      <Row justifyBetween alignCenter>
        <Label tooltip="" altTooltip="">
          Buyer Splits
        </Label>
      </Row>
      <Paper>
        <ul>
          {splitDescriptions.map((splitDescription, idx) => (
            <li key={idx}>{splitDescription}</li>
          ))}
        </ul>
        {disabled && (
          <Error>
            Buyer must be added and saved before a Buyer Split can be created.
          </Error>
        )}
        <SlimSecondaryButton
          type="button"
          onClick={onClickCreateBuyerSplit}
          data-tour="editOrCreateBuyerSplit"
          disabled={disabled}
        >
          {split ? "Edit" : "Create"} Buyer Split
        </SlimSecondaryButton>
      </Paper>
    </Column>
  );
};
